import { useTranslation } from "react-i18next";
import MarketingShell, { LegalSection } from "@/components/MarketingShell";

const ITEMS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

export default function Faq() {
  const { t } = useTranslation();
  return (
    <MarketingShell
      eyebrow={t("legal.faqpage.eyebrow")}
      title={t("legal.faqpage.title")}
    >
      {ITEMS.map((n) => (
        <LegalSection key={n} heading={t(`faq.q${n}`)}>
          <p>{t(`faq.a${n}`)}</p>
        </LegalSection>
      ))}
    </MarketingShell>
  );
}
